import React, { useState, useEffect } from "react";
import Header from "@img/headertestimoni.png";
import Profile from "@img/profile.png";
import FloatingMenu from "../components/FloatingMenu";

const Testimoni = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch(
          "https://cms.okoce.net/api/admin/testimonials"
        );
        const result = await response.json();
        const filteredTestimonials = result.data.filter(
          (testimonial) => testimonial.published_at !== null
        );
        setTestimonials(filteredTestimonials);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };

    fetchTestimonials();
  }, []);
  const indexOfLastTestimonial = currentPage * itemsPerPage;
  const indexOfFirstTestimonial = indexOfLastTestimonial - itemsPerPage;
  const currentTestimonials = testimonials.slice(
    indexOfFirstTestimonial,
    indexOfLastTestimonial
  );

  const nextPage = () => {
    if (currentPage < Math.ceil(testimonials.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <section
        className="mt-[4em] bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${Header})`,
          width: "100%",
          height: "100%",
          backgroundSize: "cover",
        }}
      >
        <div className="px-4 mx-auto max-w-screen-xl text-center py-24 lg:py-56">
          <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl">
            Yuk, Mulai Gabung dan Dapatkan Hasil Tambahan dengan daftar
          </h1>
          <p className="mb-8 text-lg font-normal text-gray-300 lg:text-xl sm:px-16 lg:px-48">
            Fondasi kami, idemu, bersama-sama kita maju dan berkembang untuk
            menciptakan masa depan bersama.
          </p>
        </div>
      </section>

      {/* Testimoni section */}
      <section className="bg-gray-100 py-12">
        <div className="container my-10 mx-auto px-4">
          <h2 className="text-4xl font-bold my-14 text-center text-sky-700">
            Pendapat Mereka Tentang Kami!
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {currentTestimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`shadow-lg rounded-lg overflow-hidden ${
                  index % 2 === 0 ? "bg-[#1c75ac]" : "bg-[#e01f31]"
                }`}
              >
                <div className="p-4">
                  <p
                    className="text-white text-base"
                    dangerouslySetInnerHTML={{
                      __html: testimonial.description,
                    }}
                  ></p>
                </div>
                <div className={`flex items-center justify-between p-4 ${
                  index % 2 === 0 ? "bg-[#1c75ac]" : "bg-[#e01f31]"
                }`}>
                  <div className="flex items-center">
                    <img
                      className="h-10 w-10 rounded-full mr-4"
                      src={Profile}
                      alt="Profile"
                    />
                    <div>
                      <p className="font-semibold text-white">
                        {testimonial.name}
                      </p>
                      <p className="text-xs text-gray-200">
                        {testimonial.occupation}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-center mt-8">
            <button
              className={`px-4 py-2 mx-2 text-white bg-sky-700 rounded ${
                currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={prevPage}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <button
              className={`px-4 py-2 mx-2 text-white bg-sky-700 rounded ${
                currentPage === Math.ceil(testimonials.length / itemsPerPage)
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
              onClick={nextPage}
              disabled={
                currentPage === Math.ceil(testimonials.length / itemsPerPage)
              }
            >
              Next
            </button>
          </div>
        </div>
      </section>
      {/* End Testimoni section */}
      <FloatingMenu />
    </>
  );
};

export default Testimoni;
